import {
  Lock,
  AlertTriangle,
  Loader2,
  CheckCircle,
} from "lucide-react"

export const Icons = {
  lock: Lock,
  warning: AlertTriangle,
  spinner: Loader2,
  check: CheckCircle,
} 